import React from 'react';
import { Box, Typography } from '@mui/material';
import { UITimeSlot } from '../../../../core/constant/constant';


interface TimeSlotButtonProps {
  timeSlot: UITimeSlot;
  label: string;
  currentTimeSlot: string;
  setTimeSlot: (timeSlot: UITimeSlot) => void;
  disabled?: boolean;
}

export const TimeSlotButton: React.FC<TimeSlotButtonProps> = ({
  timeSlot,
  label,
  currentTimeSlot,
  setTimeSlot,
  disabled = false,
}) => {
  const isSelected = currentTimeSlot === timeSlot;
  
  return (
    <Box
      onClick={() => !disabled && setTimeSlot(timeSlot)}
      sx={{
        flex: 1,
        minWidth: '150px',
        p: 2,
        border: '1px solid',
        borderColor: isSelected ? 'primary.main' : 'divider',
        borderRadius: 1,
        cursor: disabled ? 'default' : 'pointer',
        backgroundColor: isSelected ? 'rgba(149, 43, 179, 0.1)' : 'background.paper',
        textAlign: 'center',
        transition: 'all 0.2s',
        opacity: disabled ? 0.7 : 1,
        '&:hover': {
          borderColor: disabled ? (isSelected ? 'primary.main' : 'divider') : 'primary.main',
          backgroundColor: disabled 
            ? (isSelected ? 'rgba(149, 43, 179, 0.1)' : 'background.paper') 
            : (isSelected ? 'rgba(149, 43, 179, 0.1)' : 'rgba(0, 0, 0, 0.04)'),
        },
      }}
    >
      <Typography variant='subtitle1' fontWeight='medium'>
        {timeSlot}
      </Typography>
      <Typography variant='body2' color='text.secondary'>
        {label}
      </Typography>
    </Box>
  );
};